// utils/format.js
export const formatCurrency = (amount) => {
    if (!amount) return "Rs0";
    return `Rs${parseInt(amount).toLocaleString()}`;
};